import { render, staticRenderFns } from "./viewer.vue?vue&type=template&id=bee40496&scoped=true&"
import script from "./viewer.vue?vue&type=script&lang=js&"
export * from "./viewer.vue?vue&type=script&lang=js&"
import style0 from "./viewer.vue?vue&type=style&index=0&id=bee40496&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee40496",
  null
  
)

export default component.exports